import Input from 'react-bootstrap/FormControl';

const Chance = (props) => {
    return (
        <Input className='text-center' onChange={e => { props.onSelectChange(e.target.value) } } type="text"></Input>
    )
}

export default Chance